import { render, staticRenderFns } from "./InstagramIntegartion.vue?vue&type=template&id=41e9fcbc&"
import script from "./InstagramIntegartion.vue?vue&type=script&lang=js&"
export * from "./InstagramIntegartion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports